import type { SVGProps } from "react";

export function FileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V8M14 3L19 8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileSearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H12M14 3L19 8M19 8V12.5M18.5 19.5L21 22M14 17.5C14 18.163 14.2634 18.7989 14.7322 19.2678C15.2011 19.7366 15.837 20 16.5 20C17.163 20 17.7989 19.7366 18.2678 19.2678C18.7366 18.7989 19 18.163 19 17.5C19 16.837 18.7366 16.2011 18.2678 15.7322C17.7989 15.2634 17.163 15 16.5 15C15.837 15 15.2011 15.2634 14.7322 15.7322C14.2634 16.2011 14 16.837 14 17.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileSearchOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21L18.6956 18.6956M3 3L5.34315 5.34315L15.3044 15.3044M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3L19 8M14 3H8M19 8V12.5M12 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5M18.2678 19.2678C17.7989 19.7366 17.163 20 16.5 20C15.837 20 15.2011 19.7366 14.7322 19.2678C14.2634 18.7989 14 18.163 14 17.5C14 16.837 14.2634 16.2011 14.7322 15.7322C14.903 15.5614 15.096 15.4179 15.3044 15.3044M18.2678 19.2678L18.5 19.5L21 22M18.2678 19.2678C18.4386 19.097 18.5821 18.904 18.6956 18.6956M18.6956 18.6956L16.6569 16.6569L16.65 16.65L15.3044 15.3044"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V8M14 3L19 8M9 15L11 17L15 13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const FileDocIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7002 0.700195V4.7002C12.7002 4.96541 12.8056 5.21977 12.9931 5.4073C13.1806 5.59484 13.435 5.7002 13.7002 5.7002H17.7002M12.7002 0.700195H5.7002C5.16976 0.700195 4.66105 0.910909 4.28598 1.28598C3.91091 1.66105 3.7002 2.16976 3.7002 2.7002V9.7002M12.7002 0.700195L17.7002 5.7002M17.7002 5.7002V9.7002M15.7002 14.2002C15.7002 13.8024 15.5422 13.4208 15.2609 13.1395C14.9796 12.8582 14.598 12.7002 14.2002 12.7002C13.8024 12.7002 13.4208 12.8582 13.1395 13.1395C12.8582 13.4208 12.7002 13.8024 12.7002 14.2002V17.2002C12.7002 17.598 12.8582 17.9796 13.1395 18.2609C13.4208 18.5422 13.8024 18.7002 14.2002 18.7002C14.598 18.7002 14.9796 18.5422 15.2609 18.2609C15.5422 17.9796 15.7002 17.598 15.7002 17.2002M18.2002 12.7002L21.2002 18.7002M18.2002 18.7002L21.2002 12.7002M0.700195 12.7002V18.7002H1.7002C2.23063 18.7002 2.73934 18.4895 3.11441 18.1144C3.48948 17.7393 3.7002 17.2306 3.7002 16.7002V14.7002C3.7002 14.1698 3.48948 13.6611 3.11441 13.286C2.73934 12.9109 2.23063 12.7002 1.7002 12.7002H0.700195ZM8.2002 12.7002C8.59802 12.7002 8.97955 12.8582 9.26086 13.1395C9.54216 13.4208 9.7002 13.8024 9.7002 14.2002V17.2002C9.7002 17.598 9.54216 17.9796 9.26086 18.2609C8.97955 18.5422 8.59802 18.7002 8.2002 18.7002C7.80237 18.7002 7.42084 18.5422 7.13953 18.2609C6.85823 17.9796 6.7002 17.598 6.7002 17.2002V14.2002C6.7002 13.8024 6.85823 13.4208 7.13953 13.1395C7.42084 12.8582 7.80237 12.7002 8.2002 12.7002Z"
        stroke="#1976D2"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileLinkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00014 15.0003L15.0001 9.00031M11.0001 6.00031L11.4631 5.46431C12.4009 4.52663 13.6728 3.99991 14.999 4C16.3252 4.00009 17.597 4.527 18.5346 5.46481C19.4723 6.40261 19.999 7.6745 19.9989 9.00066C19.9989 10.3268 19.4719 11.5986 18.5341 12.5363L18.0001 13.0003M13.0001 18.0003L12.6031 18.5343C11.6544 19.4725 10.3739 19.9987 9.03964 19.9987C7.70535 19.9987 6.42489 19.4725 5.47614 18.5343C5.0085 18.0719 4.63724 17.5213 4.38385 16.9144C4.13047 16.3076 4 15.6565 4 14.9988C4 14.3412 4.13047 13.69 4.38385 13.0832C4.63724 12.4763 5.0085 11.9257 5.47614 11.4633L6.00014 11.0003"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function FileNewIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V8M14 3L19 8M12 11V17M9 14H15"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3L21 21M7 3H14M14 3L19 8M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M19 8V15M19 19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileFilledOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12.5 1V5C12.5 5.26522 12.6054 5.51957 12.7929 5.70711C12.9804 5.89464 13.2348 6 13.5 6H17.5M12.5 1H5.5M12.5 1L17.5 6M17.5 6V13M3.5 3V17C3.5 17.5304 3.71071 18.0391 4.08579 18.4142C4.46086 18.7893 4.96957 19 5.5 19H15.5C16.0304 19 16.5391 18.7893 16.9142 18.4142C17.2893 18.0391 17.5 17.5304 17.5 17M7.5 11H11.5M7.5 15H13.5M1.5 1L11.5 11M19.5 19L11.5 11"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const FilePdfIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.7002 0.700195V4.7002C9.7002 4.96541 9.80555 5.21977 9.99309 5.4073C10.1806 5.59484 10.435 5.7002 10.7002 5.7002H14.7002M9.7002 0.700195H2.7002C2.16976 0.700195 1.66105 0.910909 1.28598 1.28598C0.910909 1.66105 0.700195 2.16976 0.700195 2.7002V9.7002M9.7002 0.700195L14.7002 5.7002M14.7002 5.7002V9.7002M0.700195 15.7002H2.2002C2.59802 15.7002 2.97955 15.5422 3.26086 15.2609C3.54216 14.9796 3.7002 14.598 3.7002 14.2002C3.7002 13.8024 3.54216 13.4208 3.26086 13.1395C2.97955 12.8582 2.59802 12.7002 2.2002 12.7002H0.700195V18.7002M12.7002 15.7002H14.7002M15.7002 12.7002H12.7002V18.7002M6.7002 12.7002V18.7002H7.7002C8.23063 18.7002 8.73934 18.4895 9.11441 18.1144C9.48948 17.7393 9.7002 17.2306 9.7002 16.7002V14.7002C9.7002 14.1698 9.48948 13.6611 9.11441 13.286C8.73934 12.9109 8.23063 12.7002 7.7002 12.7002H6.7002Z"
        stroke="#AE2916"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function FilePreviewIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H12M14 3L19 8M19 8V12.5M18.5 19.5L21 22M9 9H10M9 13H15M9 17H11M14 17.5C14 18.163 14.2634 18.7989 14.7322 19.2678C15.2011 19.7366 15.837 20 16.5 20C17.163 20 17.7989 19.7366 18.2678 19.2678C18.7366 18.7989 19 18.163 19 17.5C19 16.837 18.7366 16.2011 18.2678 15.7322C17.7989 15.2634 17.163 15 16.5 15C15.837 15 15.2011 15.2634 14.7322 15.7322C14.2634 16.2011 14 16.837 14 17.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileStackIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V12M14 3L19 8M19 8V12M5 21H19M5 18H19M5 15H19"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const FileXlsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7002 0.700195V4.7002C10.7002 4.96541 10.8056 5.21977 10.9931 5.4073C11.1806 5.59484 11.435 5.7002 11.7002 5.7002H15.7002M10.7002 0.700195H3.7002C3.16976 0.700195 2.66105 0.910909 2.28598 1.28598C1.91091 1.66105 1.7002 2.16976 1.7002 2.7002V9.7002M10.7002 0.700195L15.7002 5.7002M15.7002 5.7002V9.7002M0.700195 12.7002L4.7002 18.7002M0.700195 18.7002L4.7002 12.7002M13.7002 17.9502C13.7002 18.3642 14.0362 18.7002 14.4502 18.7002H15.7002C15.9654 18.7002 16.2198 18.5948 16.4073 18.4073C16.5948 18.2198 16.7002 17.9654 16.7002 17.7002V16.7002C16.7002 16.435 16.5948 16.1806 16.4073 15.9931C16.2198 15.8056 15.9654 15.7002 15.7002 15.7002H14.7002C14.435 15.7002 14.1806 15.5948 13.9931 15.4073C13.8056 15.2198 13.7002 14.9654 13.7002 14.7002V13.7002C13.7002 13.435 13.8056 13.1806 13.9931 12.9931C14.1806 12.8056 14.435 12.7002 14.7002 12.7002H15.9502C16.1491 12.7002 16.3399 12.7792 16.4805 12.9199C16.6212 13.0605 16.7002 13.2513 16.7002 13.4502M7.7002 12.7002V18.7002H10.7002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function FilesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 3V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8H20M15 3H11C10.4696 3 9.96086 3.21071 9.58579 3.58579C9.21071 3.96086 9 4.46957 9 5V15C9 15.5304 9.21071 16.0391 9.58579 16.4142C9.96086 16.7893 10.4696 17 11 17H18C18.5304 17 19.0391 16.7893 19.4142 16.4142C19.7893 16.0391 20 15.5304 20 15V8M15 3L20 8M16 17V19C16 19.5304 15.7893 20.0391 15.4142 20.4142C15.0391 20.7893 14.5304 21 14 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V9C5 8.46957 5.21071 7.96086 5.58579 7.58579C5.96086 7.21071 6.46957 7 7 7H9"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FilesOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13H8"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17H8"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9H8"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2l20 20"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FileFillIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2L12.117 2.007C12.3402 2.03332 12.5481 2.13408 12.707 2.29301C12.8659 2.45194 12.9667 2.65978 12.993 2.883L13 3V7L13.005 7.15C13.0408 7.62617 13.2458 8.07383 13.5829 8.41203C13.92 8.75023 14.3669 8.95666 14.843 8.994L15 9H19L19.117 9.007C19.3402 9.03332 19.5481 9.13408 19.707 9.29301C19.8659 9.45194 19.9667 9.65978 19.993 9.883L20 10V19C20 19.7652 19.7077 20.5015 19.1827 21.0583C18.6578 21.615 17.9399 21.9501 17.176 21.995L17 22H7C6.23479 22 5.49849 21.7077 4.94174 21.1827C4.38499 20.6578 4.04989 19.9399 4.005 19.176L4 19V5C3.99996 4.23479 4.29233 3.49849 4.81728 2.94174C5.34224 2.38499 6.06011 2.04989 6.824 2.005L7 2H12ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16ZM15 12H9C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12Z"
        fill="currentColor"
      />
      <path
        d="M19 7H15L14.999 2.999L19 7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FileJpgIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.7002 0.700195V4.7002C9.7002 4.96541 9.80555 5.21977 9.99309 5.4073C10.1806 5.59484 10.435 5.7002 10.7002 5.7002H14.7002M9.7002 0.700195H2.7002C2.16976 0.700195 1.66105 0.910909 1.28598 1.28598C0.910909 1.66105 0.700195 2.16976 0.700195 2.7002V9.7002M9.7002 0.700195L14.7002 5.7002M14.7002 5.7002V9.7002M6.7002 15.7002H8.2002C8.59802 15.7002 8.97955 15.5422 9.26086 15.2609C9.54216 14.9796 9.7002 14.598 9.7002 14.2002C9.7002 13.8024 9.54216 13.4208 9.26086 13.1395C8.97955 12.8582 8.59802 12.7002 8.2002 12.7002H6.7002V18.7002M15.7002 12.7002H14.7002C14.1698 12.7002 13.6611 12.9109 13.286 13.286C12.9109 13.6611 12.7002 14.1698 12.7002 14.7002V16.7002C12.7002 17.2306 12.9109 17.7393 13.286 18.1144C13.6611 18.4895 14.1698 18.7002 14.7002 18.7002H15.7002V15.7002M0.700195 12.7002H3.7002V17.2002C3.7002 17.598 3.54216 17.9796 3.26086 18.2609C2.97955 18.5422 2.59802 18.7002 2.2002 18.7002C1.80237 18.7002 1.42084 18.5422 1.13953 18.2609C0.85823 17.9796 0.700195 17.598 0.700195 17.2002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FilePngIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.7002 0.700195V4.7002C9.7002 4.96541 9.80555 5.21977 9.99309 5.4073C10.1806 5.59484 10.435 5.7002 10.7002 5.7002H14.7002M9.7002 0.700195H2.7002C2.16976 0.700195 1.66105 0.910909 1.28598 1.28598C0.910909 1.66105 0.700195 2.16976 0.700195 2.7002V9.7002M9.7002 0.700195L14.7002 5.7002M14.7002 5.7002V9.7002M15.7002 12.7002H14.7002C14.1698 12.7002 13.6611 12.9109 13.286 13.286C12.9109 13.6611 12.7002 14.1698 12.7002 14.7002V16.7002C12.7002 17.2306 12.9109 17.7393 13.286 18.1144C13.6611 18.4895 14.1698 18.7002 14.7002 18.7002H15.7002V15.7002M0.700195 15.7002H2.2002C2.59802 15.7002 2.97955 15.5422 3.26086 15.2609C3.54216 14.9796 3.7002 14.598 3.7002 14.2002C3.7002 13.8024 3.54216 13.4208 3.26086 13.1395C2.97955 12.8582 2.59802 12.7002 2.2002 12.7002H0.700195V18.7002M6.7002 18.7002V12.7002L9.7002 18.7002V12.7002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
